import { resources } from "@constants/hardcoded-strings";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { GeneralBasicInfoValidationErrors } from "@idw-types/common/validation/verification-service-details-validation-errors";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { BaseRedirectUrl } from "@idw-types/redirect-url-information";
import { getErrorAlert } from "@utils/tab-util";

export const getGeneralBasicInfoValidationErrors = (
    rpServiceConfiguration: FormattedRpServiceConfiguration,
    redirectUrls: Array<BaseRedirectUrl>
): GeneralBasicInfoValidationErrors => {
    let count = 0;
    let redirectUrlError = null;

    const basicInfoResources = resources.pages.verificationServiceDetails.tabs.general.subTabs.basicInfo;

    let serviceNameError = null;
    if (rpServiceConfiguration.serviceName === "") {
        count += 1;
        serviceNameError = (
            <ErrorAlert>
                <span>{basicInfoResources.inputs.serviceName.validationError}</span>
            </ErrorAlert>
        );
    }

    let apiKeyError = null;
    if (rpServiceConfiguration.apiKey === "") {
        count += 1;
        apiKeyError = (
            <ErrorAlert>
                <span>{basicInfoResources.inputs.apiKey.validationError}</span>
            </ErrorAlert>
        );
    }

    let sharedSecretError = null;
    if (rpServiceConfiguration.sharedSecret === "") {
        count += 1;
        sharedSecretError = (
            <ErrorAlert>
                <span>{basicInfoResources.inputs.sharedSecret.validationError}</span>
            </ErrorAlert>
        );
    }

    if(redirectUrls.length === 0){
        count++;
        redirectUrlError = getErrorAlert(basicInfoResources.inputs.redirectUrls.validationErrors.atLeastOneUrl)

    }

    return {
        serviceNameError,
        apiKeyError,
        sharedSecretError,
        redirectUrlError,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={basicInfoResources.tabName} errorCount={count} />
    };
};
